export default __webpack_public_path__ + "static/media/pdf_file.a15bd508.jpeg";